module.exports = __webpack_public_path__ + "media/images/menu/lynx-57ede2ebb72b704f44676341856e9fe8.jpg";